import { createSlice } from '@reduxjs/toolkit';
import { mergeObject } from './utils';

export const getInitialState = () => ({
  publicForm: {
    study: '',
    strategy: '',
    signatureSet: '',
    cancer: '',
  },
  userForm: {},
  main: {
    displayTab: 'instructions',
    openSidebar: true,
    loadingData: false,
    submitted: false,
    exposureSignature: [],
    assocVarData: [],
    assocFullDataPath: '',
    expVarList: [],
    source: 'public',
    study: '',
    studyOptions: [],
    strategy: '',
    strategyOptions: [],
    rsSet: '',
    rsSetOptions: [],
    cancer: '',
    cancerOptions: [],
    assocTable: {
      hidden: [],
      pagination: {
        pageIndex: 0,
        pageSize: 5,
      },
    },
  },
  univariable: {
    loadingParams: false,
    loadingCalculate: false,
    loadingRecalculate: false,
    submitted: false,
    error: false,
    loadedParameters: false,
    id: '',
    plotPath: '',
    dataPath: '',
    assocTablePath: '',
    signature: '',
    testType: 'nonparametric',
    xlab: '',
    ylab: '',
    associationVar: {
      source: '',
      type: '',
      name: '',
      tmpName: '',
      sourceOptions: [],
      typeOptions: [],
      nameOptions: [],
      filter: '',
      log2: false,
      collapse: '',
      collapseOptions: [],
    },
    exposureVar: {
      name: '',
      // tmpName: '',
      filter: '',
      log2: false,
      // collapse: '',
      // collapseOptions: [],
    },
    resultsTable: {
      data: [],
      hidden: ['conf.level', 'conf.low', 'conf.high', 'statistic', 'df.error'],
      pagination: {
        pageIndex: 0,
        pageSize: 5,
      },
    },
  },
  multivariable: {
    loadingParams: false,
    loadingCalculate: false,
    loadingRecalculate: false,
    submitted: false,
    error: false,
    loadedParameters: false,
    id: '',
    plotPath: '',
    dataPath: '',
    assocTablePath: '',
    signature: '',
    signatureOptions: [],
    testType: 'lm',
    associationVars: [
      {
        source: '',
        type: '',
        name: '',
        tmpName: '',
        sourceOptions: [],
        typeOptions: [],
        nameOptions: [],
        filter: '',
        log2: false,
        collapse: '',
        collapseOptions: [],
      },
    ],
    exposureVar: {
      name: '',
      // tmpName: '',
      filter: '',
      log2: false,
      // collapse: '',
      // collapseOptions: [],
    },
    resultsTable: {
      data: [],
      hidden: ['conf.level', 'conf.low', 'conf.high', 'statistic', 'df.error'],
      pagination: {
        pageIndex: 0,
        pageSize: 5,
      },
    },
  },
});

export const { actions, reducer } = createSlice({
  name: 'association',
  initialState: getInitialState(),
  reducers: {
    mergeAssociation: mergeObject,
    resetAssociation: getInitialState,
  },
});
